export const SITE = {
  name: "Desantrix",
  email: "enquiries@desantrix.com",
  supportEmail: "support@desantrix.com",
  welcomeEmail: "welcome@desantrix.com",
  whatsapp: "919000000000",
  whatsappMessage: "Hi Desantrix, I'd like to discuss a project.",
  location: "India",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "Divisions", id: "divisions" },
  { label: "Academy", id: "academy" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];

export const HERO = {
  eyebrow: "Parent Technology Company · Serving Clients Worldwide",
  lines: ["ONE PARTNER.", "EVERY DIGITAL", "CAPABILITY."],
  sub: "Desantrix is an international technology partner for startups, businesses and individuals — designing, building, managing and supporting everything digital through focused divisions, beginning with Desantrix Web.",
  primaryCta: "Start a Conversation",
  secondaryCta: "Explore Capabilities",
  badges: ["Global Partner", "20+ Capabilities", "On-Time Delivery"],
};

export const MARQUEE_ITEMS = [
  "GLOBAL TECHNOLOGY PARTNER",
  "FULL-STACK DIGITAL CAPABILITIES",
  "DESANTRIX WEB — LIVE",
  "DESANTRIX ACADEMY — COMING SOON",
  "DESANTRIX MEDIA — COMING SOON",
  "DESANTRIX SUPPORT — COMING SOON",
  "SERVING CLIENTS WORLDWIDE",
];

export const TRUST_ROW = [
  { icon: "Globe2", title: "One partner, every capability", desc: "Engineering, management, security and creative production under one roof." },
  { icon: "Users", title: "A dedicated team on every project", desc: "Design, engineering and delivery handled by a full team — never a single point of failure." },
  { icon: "CalendarCheck", title: "On-time, every time", desc: "Milestones and deadlines agreed in writing before work begins — and met." },
  { icon: "Rocket", title: "Serving clients worldwide", desc: "Based in India, delivering remotely for clients across the globe." },
];

export const STATS = [
  { value: 20, suffix: "+", label: "Capabilities under one roof" },
  { value: 4, suffix: "", label: "Focused divisions" },
  { value: 1, suffix: " day", label: "Maximum reply time" },
  { value: 100, suffix: "%", label: "Projects ship with an admin panel" },
];

export const CAPABILITIES = [
  {
    icon: "Code2",
    name: "Build & Engineering",
    tagline: "From first sketch to production.",
    items: ["Website Design & Development", "App Development", "E-commerce Stores", "Cloud Application Development & Deployment", "Domain, Hosting & Email Setup", "Testing & QA", "Updates & Optimization"],
  },
  {
    icon: "PenTool",
    name: "Design & Brand",
    tagline: "Interfaces and identities people remember.",
    items: ["UI/UX Design", "Branding & Logo Design", "Landing Pages & Conversion Design", "Design Systems & Style Guides"],
  },
  {
    icon: "ShieldCheck",
    name: "Manage, Grow & Support",
    tagline: "We run it, so you can grow it.",
    items: ["SEO & Website Management", "Digital Marketing & Analytics Setup", "Website Maintenance & Support", "Basic Security Audits", "AI Chatbots & Workflow Automation", "Customer Support Teams — Chat, Call & Email"],
  },
  {
    icon: "Palette",
    name: "Create & Produce",
    tagline: "Content that looks the part.",
    items: ["Image Editing & Production", "Graphics & Animation", "Video Editing", "Social Media Creatives"],
    more: true,
  },
];

export const ADMIN_PANEL_HIGHLIGHT = {
  title: "Your own admin panel — included with every build",
  desc: "Every Desantrix project ships with a custom admin panel, so you can access and manage your data, content and customers yourself — easily, from anywhere, without any third-party software.",
  points: ["Manage content, users and data in one place", "No third-party tools or extra software needed", "Simple enough for non-technical teams"],
};

export const PROCESS = [
  { icon: "Search", step: "01", title: "Discover", desc: "We start with a conversation about your goals, users and constraints — then write down exactly what will be delivered, and when." },
  { icon: "PenLine", step: "02", title: "Design", desc: "Wireframes and visual design you can react to before a single line of code — so nothing is built twice." },
  { icon: "Hammer", step: "03", title: "Build", desc: "Engineering, content and your admin panel, delivered in milestones you can review as they land." },
  { icon: "Rocket", step: "04", title: "Launch & Support", desc: "Deployment, handover training and ongoing care — your dedicated team stays on after launch." },
];

export const DIVISIONS = [
  {
    name: "Desantrix Web",
    status: "Live",
    active: true,
    desc: "End-to-end website design and development — fast, mobile-first, SEO-ready websites for businesses and individuals.",
  },
  {
    name: "Desantrix Academy",
    status: "Coming Soon",
    active: false,
    notify: true,
    desc: "Online courses and certifications — hands-on, project-first programs for modern developers and creators.",
  },
  {
    name: "Desantrix Media",
    status: "Coming Soon",
    active: false,
    desc: "Video production, graphics, animation and digital storytelling for brands.",
  },
  {
    name: "Desantrix Support",
    status: "Coming Soon",
    active: false,
    desc: "Dedicated customer support operations and technical care for growing businesses.",
  },
];

export const ACADEMY = {
  eyebrow: "Launching soon",
  title: "Desantrix Academy is coming. Be the first to know.",
  sub: "Hands-on, project-first courses and certifications for developers and creators. Join the waiting list and we'll email you the moment enrolment opens — plus early-access pricing.",
  perks: ["Early access before public launch", "Founding-student pricing", "Curriculum previews and free lessons"],
  interests: ["Full Stack Web Development", "Basic Ethical Hacking", "Database Management", "Not sure yet"],
};

export const COURSES = [
  {
    icon: "Braces",
    title: "Full Stack Web Development",
    level: "Beginner → Job-ready",
    duration: "16 weeks",
    desc: "Build and deploy complete web applications from scratch — front-end, back-end, databases and hosting — with real projects for your portfolio.",
    topics: ["HTML, CSS & JavaScript", "React front-ends", "APIs & back-end", "Databases & deployment"],
  },
  {
    icon: "ShieldAlert",
    title: "Basic Ethical Hacking",
    level: "Beginner",
    duration: "8 weeks",
    desc: "Learn how attackers think and how to defend against them — networking fundamentals, common vulnerabilities and safe, legal lab practice.",
    topics: ["Networking & Linux basics", "Web vulnerabilities (OWASP)", "Scanning & recon tools", "Responsible disclosure"],
  },
  {
    icon: "Database",
    title: "Database Management",
    level: "Beginner → Intermediate",
    duration: "8 weeks",
    desc: "Design, query, secure and back up the data behind modern applications — from SQL fundamentals to document databases and administration.",
    topics: ["SQL fundamentals", "Data modelling & normalisation", "MongoDB & NoSQL", "Backups, security & performance"],
  },
];

export const INDUSTRIES = [
  "Startups", "E-commerce & Retail", "Education & Coaching", "Healthcare & Clinics", "Real Estate",
  "Hospitality & Travel", "Professional Services", "Creators & Media", "Non-profits", "Manufacturing & Trade",
];

// Replace these sample quotes with real client feedback before launch.
export const TESTIMONIALS = [
  { quote: "Desantrix rebuilt our store from the ground up and handed us an admin panel our team actually enjoys using. Orders went up, support tickets went down, and everything landed on the day they promised.", name: "Aarav Mehta", role: "Founder", company: "D2C skincare brand", service: "E-commerce website + admin panel" },
  { quote: "We work across three time zones and never once felt the distance. Clear milestones, honest updates, and a finished product that looks far more expensive than it was.", name: "Sarah Whitfield", role: "Operations Director", company: "Consulting firm, UK", service: "Website, SEO & maintenance" },
  { quote: "Their team set up our cloud deployment, ran a security audit and now handles our customer chat support. One partner, one invoice, zero finger-pointing — exactly what we needed.", name: "Rohan Iyer", role: "Co-founder", company: "SaaS startup", service: "Cloud, security & support team" },
  { quote: "From logo to launch video to the website itself, everything felt like one brand. Desantrix understood our audience faster than agencies we'd paid three times as much.", name: "Priya Nair", role: "Marketing Lead", company: "Education platform", service: "Branding, video & website" },
];

export const COMPANY_COPY = [
  "Desantrix is a technology company based in India, serving clients worldwide. We are a technology partner for startups, businesses and individuals who need reliable, modern technology — designed, built, managed and supported by one accountable team.",
  "Our first division, Desantrix Web, delivers professional website design and development. Desantrix is built to grow: Desantrix Academy, Desantrix Media and Desantrix Support are planned as the company expands.",
];

export const FOUNDER = {
  name: "Deshant Sharma",
  role: "Founder, Desantrix",
  degree: "UG — JECRC University",
  location: "India",
  bio: [
    "I'm Deshant Sharma, founder of Desantrix. I completed my UG from JECRC University and lead a team that builds professional, high-performing technology for businesses and individuals — from local startups to clients around the world.",
    "Our team works directly with every client — from understanding your goals to designing, building, and launching — so every project is delivered on time, without the overhead of a large agency. Our focus is simple: build technology that genuinely helps your business grow.",
  ],
};

export const FAQ = [
  { q: "What kind of clients does Desantrix work with?", a: "Startups, established businesses and individuals — in India and internationally. If you need something designed, built, managed or supported, we're the right team to talk to." },
  { q: "Do you work with clients outside India?", a: "Yes. Most of our work is delivered remotely, with communication over email, WhatsApp and video calls in your time zone." },
  { q: "How long does a typical website take?", a: "A focused business website usually takes two to four weeks from kickoff to launch. Larger apps and cloud platforms are scoped individually, with milestones agreed in writing before work begins." },
  { q: "Will I be able to manage my site myself after launch?", a: "Absolutely. Every project ships with a custom admin panel so you can update content, users and data without any third-party software or technical help." },
  { q: "Do you offer ongoing maintenance and support?", a: "Yes — website maintenance, security audits, updates and dedicated customer-support teams are all part of what we do. Existing clients can reach us anytime at support@desantrix.com." },
  { q: "When does Desantrix Academy launch?", a: "We're building the first courses now. Join the waiting list on this page and you'll be the first to know when enrolment opens, with founding-student pricing." },
];

export const ENQUIRY_TOPICS = [
  "A website — Desantrix Web",
  "App development",
  "Cloud & deployment",
  "UI/UX & branding",
  "Support teams",
  "Creative & media production",
  "Something else",
];

export const PRIVACY_POLICY = [
  { h: "Information we collect", b: "When you contact Desantrix through this website, WhatsApp or email, or join the Desantrix Academy waiting list, we collect the details you share with us — your name, email address, phone number and information about your project or interests. We do not collect any other personal data automatically beyond basic, anonymous website usage analytics." },
  { h: "How we use your information", b: "Your details are used only to respond to your enquiry, prepare quotes, deliver our services, notify you about Desantrix Academy if you asked us to, and communicate with you about your project. We do not sell, rent or share your personal information with third parties for marketing purposes." },
  { h: "Emails from Desantrix", b: "Welcome and confirmation messages are sent from welcome@desantrix.com. Enquiries are handled from enquiries@desantrix.com, and existing clients can reach our team at support@desantrix.com. You can ask to be removed from the Academy waiting list at any time." },
  { h: "Data storage & security", b: "Enquiry and waiting-list information is stored securely and access is restricted to the Desantrix team. We retain records only as long as needed to serve you and meet our legal obligations." },
  { h: "Your rights", b: "You may request a copy of the personal data we hold about you, ask us to correct it, or ask us to delete it entirely at any time by writing to enquiries@desantrix.com. We will act on every request promptly." },
  { h: "Intellectual property", b: "All content on this website — including the Desantrix name, logo, text and design — is the property of Desantrix and may not be reproduced without written permission. © 2026 Desantrix. All rights reserved." },
  { h: "Contact for legal matters", b: "For any questions about this policy or your data, contact us at enquiries@desantrix.com." },
];

export const TERMS_OF_SERVICE = [
  { h: "Agreement", b: "By using this website or engaging Desantrix for any service, you agree to these terms. Individual projects are governed by a written proposal or agreement, which takes precedence over these general terms where they differ." },
  { h: "Scope of work", b: "Every project begins with an agreed written scope, timeline and deliverables. Work outside that scope is quoted separately before it starts, so there are never surprise costs." },
  { h: "Payments", b: "Project fees, milestones and payment schedules are set out in your proposal. Work on each milestone begins once the corresponding payment is received. Ongoing services such as maintenance and support are billed as agreed in your service plan." },
  { h: "Client responsibilities", b: "You agree to provide content, access, feedback and approvals in a timely manner, and confirm that any material you supply does not infringe the rights of others. Delays in providing these may shift agreed timelines." },
  { h: "Ownership & licences", b: "On full payment, you own the final deliverables created for your project, including your website, app and admin panel. Desantrix retains ownership of its internal tools, frameworks and know-how, and may reference completed work in its portfolio unless you ask otherwise in writing." },
  { h: "Third-party services", b: "Domains, hosting, cloud platforms and other third-party services are subject to their own terms and fees. Desantrix sets these up on your behalf but is not responsible for changes to their pricing or availability." },
  { h: "Warranties & liability", b: "We deliver work with professional care and correct defects reported within the agreed support period at no extra cost. Desantrix is not liable for indirect losses, lost profits or damage arising from misuse, third-party failures or changes made by others after handover." },
  { h: "Desantrix Academy waiting list", b: "Joining the waiting list is free and creates no obligation to enrol. Launch dates, course content and pricing may change before release. You may leave the list at any time." },
  { h: "Termination", b: "Either party may end an engagement in writing. Work completed to that point is payable, and any deliverables paid for in full are handed over." },
  { h: "Governing law & contact", b: "These terms are governed by the laws of India. Questions about these terms can be sent to enquiries@desantrix.com." },
];
